export const EVENTS = {
  PHASE_FILTERED: "phase:filtered",
  INDICATOR_FILTERED: "indicator:filtered",
  YEAR_FILTERED: "year:filtered",
  QUESTIONNAIRE_DATA_SAVED: "edit_questionnaire:saved",
  REGION_FILTERED: "region:filtered",
  REGION_TRANSLATED: "region:translated",
  DEFAULT_YEAR: "default_year",
  LATEST_YEAR: "latest_year",
};
